import "@hotwired/turbo-rails";
import "../channels";
import "../controllers";
import "../initializers";

// @ts-ignore
Turbo.session.drive = false;

// import { isEnabled } from "../helpers/flipper";
// if (await isEnabled("test_feature")) {
// } else {
// }
